import React, { useEffect, useState } from "react";
import { Avatar, Divider, Grid } from "@mui/material"
// import SlideDialog from "components/SlideDialog/SlideDialog"
// import MatchGameForm from "pages/Tournament/Match/Component/common/MatchGameForm";
// import { getMatchGroupDetail } from "service/matchService";
// import EmptyData from "components/TopCourtComponents/Placeholder/EmptyData";
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel"
import { color } from "constant/constant";
import moment from "moment";
import { WinnerCheckSolid } from "components/TopCourtComponents/Image";
import { MatchLiveStatusMap } from "helper/Match";
import { getUserAvatar } from "helper/User";
import { loadImages } from "helper/Image";

function TournamentLiveCard ({
    data, reloadLiveMatch
}) {

    let dur = data.isTournament ? moment.duration(moment(data.endMatch).diff(moment(data.startMatch))) : null
    let difMins = data.isTournament ? moment(data.endMatch).format('mm') != moment(data.startMatch).format('mm') : false
    let h = data.isTournament ? Math.floor(dur.asHours()) : null
    let m = data.isTournament ? (dur.minutes() < 1 && difMins) ? 1 : dur.minutes() : null
    const matchHours = data.isTournament ? `${h}h ${m}m` : null
    
    const winnerSide = data?.winner !== "draw" ? data?.isTournament ? data?.endMatch ? data?.winner : '' : data?.winner : null
    console.log('here data', data)

    const [ openDialog, setOpenDialog ] = useState({
        open: false,
        data: null
    })

    useEffect(() => {
        console.log('here match info', openDialog)
    }, [openDialog])

    return (
        <>
            <Grid xs={12} onClick={(e) => {
                console.log('here match info - clicked', openDialog)
                setOpenDialog({
                    open: true,
                    data: data
                })
            }}>
                <Grid container xs={12} justifyContent={'space-between'} alignItems={"center"}>
                    <Grid>
                        <TCLabel>{data.name}</TCLabel>
                    </Grid>
                    <Grid >
                        <TCLabel>
                            <div style={{ display: 'flex', gap: 2, alignItems: 'center'}}>
                                {MatchLiveStatusMap(data)}
                                {
                                    (data.startMatch && data.endMatch) &&
                                    <div style={{
                                        width: '100%', textAlign: 'right'
                                    }}><TCLabel subtitle>(Time: {matchHours})</TCLabel></div>
                                }
                            </div>
                        </TCLabel>
                    </Grid>
                </Grid>
                <Grid xs={12} container justifyContent={'space-between'} alignItems={"center"} p={1} pt={.6} pb={.7}>
                    <Grid
                        style={{
                            opacity: winnerSide && (winnerSide === "a" ? 1 : 0.4),
                        }}
                    >
                        {
                            data.playersSideA.map( v => {
                                return (
                                    <Grid display={"flex"} gap={0.5}>
                                        <Avatar
                                            bgColor={"transparent"}
                                            src={getUserAvatar(v)}
                                            alt={v.name}
                                            sx={{
                                                width: 20,
                                                height: 20
                                            }}
                                        />
                                        <TCLabel>{v.name}</TCLabel>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                    <div style={{
                        display: 'flex', gap: 4, alignItems: 'center', marginRight: -8
                    }}>
                        {/* {
                            data?.matchScores && data.matchScores.map(v => {
                                if ("a" == v.side) {
                                return (
                                        <TCLabel>
                                        {v.score}
                                        </TCLabel>
                                    )
                                }
                            })
                        } */}
                        {
                            (winnerSide && winnerSide == "a") &&
                            <WinnerCheckSolid color={color.blueIndoor_2} />
                        }
                        {
                            data?.matchScores
                                ?.filter(s => s.side === "a")
                                .map(a => {
                                const b = data.matchScores.find(
                                    x => x.side === "b" && x.roundNumber === a.roundNumber
                                );


                                const highlight = b ? a.score > b.score || a.score == b.score : false; // only highlight if we know A and B
                                let woWinner = false
                                if (data.isWO) {
                                    woWinner = (winnerSide == "a")
                                }

                                return (
                                        <TCLabel style={{
                                            opacity: data.isWO ? woWinner ? 1 : 0.4 : data.endMatch ? highlight ? 1 : 0.4 : 1,
                                        }}>
                                        {a.score}
                                        </TCLabel>
                                    )
                                })
                        }
                        <TCLabel>{data.matchScores.length == 0 && 0}</TCLabel>
                    </div>
                </Grid>
                <Grid xs={12} container justifyContent={'space-between'} alignItems={"center"} p={1} pt={.6}>
                    <Grid 
                        style={{
                            opacity: winnerSide && (winnerSide === "b" ? 1 : 0.4),
                        }}
                    >
                        {
                            data.playersSideB.map( v => {
                                return (
                                    <Grid display={"flex"} gap={0.5}>
                                        <Avatar
                                            bgColor={"transparent"}
                                            src={getUserAvatar(v)}
                                            alt={v.name}
                                            sx={{
                                                width: 20,
                                                height: 20
                                            }}
                                        />
                                        <TCLabel>{v.name}</TCLabel>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                    <div style={{
                        display: 'flex', gap: 4, alignItems: 'center', marginRight: -8
                    }}>
                        {/* {
                            data?.matchScores && data.matchScores.map(v => {
                                if ("b" == v.side) {
                                return (
                                        <TCLabel>
                                        {v.score}
                                        </TCLabel>
                                    )
                                }
                            })
                        } */}
                        {
                            (winnerSide && winnerSide == "b") &&
                            <WinnerCheckSolid color={color.blueIndoor_2} />
                        }
                        {
                            data?.matchScores
                                ?.filter(s => s.side === "b")
                                .map(b => {
                                const a = data.matchScores.find(
                                    x => x.side === "a" && x.roundNumber === b.roundNumber
                                );

                                const highlight = a ? b.score > a.score || b.score == a.score : false; // only highlight if we know A and B
                                let woWinner = false
                                if (data.isWO) {
                                    woWinner = (winnerSide == "b")
                                }

                                return (
                                        <TCLabel style={{
                                            opacity: data.isWO ? woWinner ? 1 : 0.4 : data.endMatch ? highlight ? 1 : 0.4 : 1,
                                        }}>
                                        {b.score}
                                        </TCLabel>
                                    )
                                })
                            }
                        <TCLabel>{data.matchScores.length == 0 && 0}</TCLabel>
                    </div>
                </Grid>
                <Divider sx={{ marginY: .5, marginTop: 0, background: color.blueIndoor_1}}/>
            </Grid>
            {/* {
                (openDialog.open && openDialog.data) &&
                <SlideDialog
                    isOpen={openDialog.open} 
                    setIsOpen={(e) => {
                        setOpenDialog({
                            open: false,
                            data: null
                        })
                    }}
                >
                    <MatchGameForm match={data} isOpen={openDialog.open} setOpenDialog={() => {
                        setOpenDialog({
                            open: false,
                            data: null
                        })
                    }} loadMatchDetail={() => {
                        reloadLiveMatch()
                        setOpenDialog({
                            open: false,
                            data: null
                        })
                    }} loadInfoOnly={() => {
                        reloadLiveMatch()
                    }} 
                    setLoading={() => {

                    }}
                    />
                </SlideDialog>
            } */}
        </>
    )
}

export default TournamentLiveCard